import { useState } from 'react';

import { useLocation, useHistory } from 'react-router-dom';

export const useCodesFromQuery = () => {
  const searchParams = new URLSearchParams(useLocation().search);
  const history = useHistory();

  const [spaceCode, setSpaceCode] = useState(
    searchParams.get('spaceCode') || ''
  );
  const [verificationCode, setVerificationCode] = useState(
    searchParams.get('verificationCode') || ''
  );

  const clearQuery = () => {
    history.replace({ search: '' });
    setVerificationCode('');
  };

  return {
    spaceCode,
    setSpaceCode,
    verificationCode,
    setVerificationCode,
    clearQuery,
  };
};
